import { render, staticRenderFns } from "./LocationIcon.vue?vue&type=template&id=0bfce82d&"
import script from "./LocationIcon.vue?vue&type=script&lang=ts&"
export * from "./LocationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports